import StoryTalerDetailsViewComponent from './containers/DetailsView';
import config from './package.json';
import { ModuleConfig } from '../../types/configTypes';
import ehubCardViewRegistry from '../../registries/EhubCardViewRegistry';
import myPrivilegesCardViewRegistry from '../../registries/MyPrivilegesCardViewRegistry';
import cardViewSaga from './sagas/ehubSaga';
import MyPrivilegesSaga from './sagas/myPrivilegesSaga';
import StoryTalerCardViewComponent from './containers/CardView';
import StoryTalerMyPrivilegesCardView from './containers/MyPrivilegesCardView';
import StoryTalerMyPrivilegesDetailsView from './containers/MyPrivilegesDetailsView';

import WomanProductSaga from './sagas/checkCoverageSaga';
import CheckCoverageCardViewRegistry from '../../registries/CheckCoverageCardViewRegistry';
import WomanProductCardView from './containers/CheckCoverageCardView';
import WomanProductDetailsView from './containers/CheckCoverageDetailsView';

ehubCardViewRegistry.register(
  config.id,
  StoryTalerCardViewComponent,
  StoryTalerDetailsViewComponent,
  false,
  config.ehubReducerSubName,
);
ehubCardViewRegistry.register(
  config.disabledId,
  StoryTalerCardViewComponent,
  StoryTalerDetailsViewComponent,
  true,
  config.ehubReducerSubName,
);
ehubCardViewRegistry.register(
  config.lockedId,
  StoryTalerCardViewComponent,
  StoryTalerDetailsViewComponent,
  true,
  config.ehubReducerSubName,
);

myPrivilegesCardViewRegistry.register(
  config.id,
  StoryTalerMyPrivilegesCardView,
  StoryTalerMyPrivilegesDetailsView,
  false,
  config.myPrivigesReducerSubName,
);

myPrivilegesCardViewRegistry.register(
  config.disabledId,
  StoryTalerMyPrivilegesCardView,
  StoryTalerMyPrivilegesDetailsView,
  true,
  config.myPrivigesReducerSubName,
);

myPrivilegesCardViewRegistry.register(
  config.lockedId,
  StoryTalerMyPrivilegesCardView,
  StoryTalerMyPrivilegesDetailsView,
  true,
  config.myPrivigesReducerSubName,
);

CheckCoverageCardViewRegistry.register(
  config.id,
  WomanProductCardView,
  WomanProductDetailsView,
  false,
  config.womanProductReducerSubName,
);

CheckCoverageCardViewRegistry.register(
  config.disabledId,
  WomanProductCardView,
  WomanProductDetailsView,
  true,
  config.womanProductReducerSubName,
);

CheckCoverageCardViewRegistry.register(
  config.lockedId,
  WomanProductCardView,
  WomanProductDetailsView,
  true,
  config.womanProductReducerSubName,
);

export default {
  config,
  sagas: [cardViewSaga, MyPrivilegesSaga, WomanProductSaga],
} as ModuleConfig;
